import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "billetage-form container p-15 p-md-40" }
const _hoisted_3 = { class: "fw-bold text-black mb-15 mb-md-25" }
const _hoisted_4 = { class: "div row" }
const _hoisted_5 = { class: "div col-md-12" }
const _hoisted_6 = { class: "div row" }
const _hoisted_7 = { class: "div col-md-6" }
const _hoisted_8 = { class: "div form-group mb-12" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_11 = {
  key: 1,
  class: "text-info"
}
const _hoisted_12 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_13 = { class: "div col-md-6" }
const _hoisted_14 = { class: "div form-group mb-12" }
const _hoisted_15 = { class: "div d-flex align-items-center justify-content-between" }
const _hoisted_16 = { class: "text-danger" }
const _hoisted_17 = { class: "div row" }
const _hoisted_18 = { class: "div col-md-6" }
const _hoisted_19 = { class: "div form-group mb-12" }
const _hoisted_20 = { class: "div col-md-6" }
const _hoisted_21 = { class: "div form-group mb-12" }
const _hoisted_22 = { class: "div row" }
const _hoisted_23 = { class: "div col-md-6" }
const _hoisted_24 = { class: "div form-group mb-12" }
const _hoisted_25 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_26 = { class: "div row" }
const _hoisted_27 = { class: "div col-md-6 mb-md-12" }
const _hoisted_28 = { class: "div border border-primary mb-5" }
const _hoisted_29 = {
  class: "div row fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_30 = { class: "col-md-5" }
const _hoisted_31 = {
  key: 0,
  class: "fs-5 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_32 = { class: "div px-3" }
const _hoisted_33 = { class: "div row align-items-center" }
const _hoisted_34 = { class: "div col-md-4 px-1" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "div col-md-4 px-1" }
const _hoisted_37 = { class: "div col-md-4 px-1" }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = { class: "div col-md-6 mb-md-12" }
const _hoisted_40 = { class: "div border border-primary mb-5" }
const _hoisted_41 = {
  class: "div row fw-bold py-2",
  style: {"background-color":"#a40a0a"}
}
const _hoisted_42 = { class: "div col-md-5" }
const _hoisted_43 = {
  class: "fs-5 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_44 = { class: "div px-3" }
const _hoisted_45 = { class: "div row align-items-center" }
const _hoisted_46 = { class: "div col-md-4 px-1" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { class: "div col-md-4 px-1" }
const _hoisted_49 = { class: "div col-md-4 px-1" }
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = { class: "row mt-3" }
const _hoisted_52 = { class: "col-md-2" }
const _hoisted_53 = { class: "form-group mb-2" }
const _hoisted_54 = { class: "div mb-3 mt-1" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  class: "div modal fade",
  id: "addClientModal",
  tabindex: "-1",
  "aria-labelledby": "addClientModalLabel",
  "aria-hidden": "true"
}
const _hoisted_57 = { class: "div modal-dialog" }
const _hoisted_58 = { class: "div modal-content" }
const _hoisted_59 = { class: "div modal-body" }
const _hoisted_60 = { class: "div mb-3" }
const _hoisted_61 = { class: "div mb-3" }
const _hoisted_62 = { class: "div mb-3" }
const _hoisted_63 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_Form, {
        ref: "billetageForm",
        onSubmit: _ctx.addOperation,
        "validation-schema": _ctx.operationSchema
      }, {
        default: _withCtx(({ setFieldValue }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label d-block text-black fw-semibold mb-5" }, [
                      _createTextVNode(" Caisse"),
                      _createElementVNode("span", { class: "span text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "caisse" }, {
                      default: _withCtx(({ errors }) => [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedCaisse,
                          "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCaisse) = $event)),
                            (value) => {
                        _ctx.selectedCaisse = value;
                        setFieldValue('caisse', value);
                      }
                          ],
                          options: _ctx.caissesOptions,
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          placeholder: "Sélectionner la caisse",
                          class: "w-100",
                          disabled: _ctx.caissesOptions.length === 0
                        }, null, 8, ["modelValue", "options", "disabled", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(errors[0]), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ErrorMessage, {
                      name: "caisse",
                      class: "text-danger"
                    }),
                    (_ctx.caissesOptions.length === 1)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_10, " Cette caisse a été automatiquement sélectionnée "))
                      : (_ctx.caissesOptions.length > 1)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_11, " Vous avez " + _toDisplayString(_ctx.caissesOptions.length) + " caisses ouvertes. Veuillez en sélectionner une. ", 1))
                        : (_openBlock(), _createElementBlock("small", _hoisted_12, " Aucune caisse ouverte. Veuillez ouvrir une caisse. "))
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label d-block text-black fw-semibold mb-5" }, [
                        _createTextVNode(" Client"),
                        _createElementVNode("span", { class: "span text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("button", {
                        class: "button btn btn-primary btn-sm",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAddClientModal && _ctx.openAddClientModal(...args)), ["prevent"]))
                      }, " Ajouter ")
                    ]),
                    _createVNode(_component_Field, { name: "client" }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_Multiselect, {
                          options: _ctx.clientsOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          "model-value": field.value,
                          placeholder: "Sélectionner le client",
                          class: "w-100",
                          "onUpdate:modelValue": field.onChange,
                          onBlur: field.onBlur
                        }, null, 8, ["options", "model-value", "onUpdate:modelValue", "onBlur"]),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(errors[0]), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "client",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label d-block text-black fw-semibold mb-5" }, " Référence document ", -1)),
                    _createVNode(_component_Field, {
                      name: "referenceDoc",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer la référence du document",
                      modelValue: _ctx.referenceDoc,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referenceDoc) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "referenceDoc",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label d-block text-black fw-semibold mb-5" }, [
                      _createTextVNode(" Motifs"),
                      _createElementVNode("span", { class: "span text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "motif" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: _ctx.motif,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.motif) = $event)),
                          options: _ctx.motifOptions,
                          "preserve-search": true,
                          searchable: true,
                          placeholder: "Sélectionner le motif",
                          label: "label",
                          "track-by": "value"
                        }, field), null, 16, ["modelValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "motif",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label d-block text-black fw-semibold mb-5" }, [
                      _createTextVNode(" Montant de l'opération"),
                      _createElementVNode("span", { class: "span text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "montant",
                      type: "number",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le montant de l'opération",
                      modelValue: _ctx.montant,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.montant) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "montant",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              (_ctx.montantError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.montantError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "div col-md-7" }, [
                        _createElementVNode("h3", { class: "h3 fs-4 text-white" }, "Billetage Encaissement")
                      ], -1)),
                      _createElementVNode("div", _hoisted_30, [
                        (_ctx.montantTotalEncaissement)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_31, _toDisplayString((_ctx.montantTotalEncaissement)) + " Fcfa ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "div row mt-2" }, [
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Monnaie")
                        ]),
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Quantité")
                        ]),
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Montant")
                        ])
                      ], -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("hr", { class: "hr mt-0" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageList, (billetage, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "div container-tight m-0 py-1"
                        }, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _withDirectives(_createElementVNode("input", {
                                name: "monnaie",
                                "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                readonly: "",
                                class: "form-control compact-input",
                                placeholder: "Monnaie"
                              }, null, 8, _hoisted_35), [
                                [_vModelText, billetage.libelle]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_Field, {
                                name: `billetageList[${index}].qteBillet`,
                                type: "number",
                                min: "0",
                                modelValue: billetage.qteBillet,
                                "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                onInput: event => _ctx.handleBilletageInput(event, billetage, 'encaissement'),
                                onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.restrictInput($event))),
                                class: "form-control compact-input",
                                placeholder: "Qté"
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `billetageList[${index}].qteBillet`,
                                class: "text-danger compact-error"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                readonly: "",
                                placeholder: "Montant",
                                class: "form-control compact-input"
                              }, null, 8, _hoisted_38), [
                                [_vModelText, billetage.montant]
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "div col-md-7" }, [
                        _createElementVNode("h3", { class: "h3 fs-4 text-white" }, "Reliquat")
                      ], -1)),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("h3", _hoisted_43, _toDisplayString(Number(_ctx.montantTotalSortie)) + " Fcfa ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "div row mt-2" }, [
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Monnaie")
                        ]),
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Quantité")
                        ]),
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Montant")
                        ])
                      ], -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("hr", { class: "hr mt-0" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageSortieList, (billetage, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "div container-tight m-0 py-1"
                        }, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _withDirectives(_createElementVNode("input", {
                                name: "monnaie",
                                "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                readonly: "",
                                class: "form-control compact-input",
                                placeholder: "Monnaie"
                              }, null, 8, _hoisted_47), [
                                [_vModelText, billetage.libelle]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_Field, {
                                name: `billetageSortieList[${index}].qteBillet`,
                                type: "number",
                                min: "0",
                                modelValue: billetage.qteBillet,
                                "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                onInput: event => _ctx.handleBilletageInput(event, billetage, 'sortie'),
                                onKeypress: _cache[6] || (_cache[6] = ($event: any) => (_ctx.restrictInput($event))),
                                class: "form-control compact-input",
                                placeholder: "Qté"
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `billetageSortieList[${index}].qteBillet`,
                                class: "text-danger compact-error"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                readonly: "",
                                placeholder: "Montant",
                                class: "form-control compact-input"
                              }, null, 8, _hoisted_50), [
                                [_vModelText, billetage.montant]
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-10" }, null, -1)),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label fw-semibold mb-1 text-start d-block" }, " Reliquat à retourner ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm shadow-none text-start",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reliquatRetourner) = $event)),
                      readonly: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.reliquatRetourner,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary top-end",
                  disabled: !!_ctx.montantError
                }, " Envoyer ", 8, _hoisted_55),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger mx-1",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelOperation && _ctx.cancelOperation(...args)))
                }, " Annuler ")
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "div modal-header" }, [
            _createElementVNode("h5", {
              class: "h5 modal-title",
              id: "addClientModalLabel"
            }, "Ajouter un client"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_Form, {
              ref: "clientForm",
              onSubmit: _ctx.addClient,
              "validation-schema": _ctx.clientSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_60, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", {
                    for: "clientNom",
                    class: "form-label"
                  }, [
                    _createTextVNode("Nom"),
                    _createElementVNode("span", { class: "span text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "nom",
                    type: "text",
                    class: "form-control",
                    id: "clientNom",
                    modelValue: _ctx.newClient.nom,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newClient.nom) = $event)),
                    placeholder: "Entrer le nom du client"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "nom",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", {
                    for: "prenom",
                    class: "form-label"
                  }, "Prénom", -1)),
                  _createVNode(_component_Field, {
                    name: "prenom",
                    type: "text",
                    class: "form-control",
                    id: "prenom",
                    modelValue: _ctx.newClient.prenom,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newClient.prenom) = $event)),
                    placeholder: "Entrer le prénom du client"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "prenom",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", {
                    for: "telephone",
                    class: "form-label"
                  }, "Numéro de téléphone", -1)),
                  _createVNode(_component_Field, {
                    name: "telephone",
                    modelValue: _ctx.newClient.telephone,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newClient.telephone) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_vue_tel_input, _mergeProps({
                        placeholder: "Entrer le numéro de téléphone",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        defaultCountry: "BJ",
                        mode: "international",
                        onValidate: _ctx.validate,
                        class: "shadow-none fs-md-15 text-black py-2"
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (!_ctx.validPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, "Veuillez entrer un numéro correcte"))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ErrorMessage, {
                    name: "telephone",
                    class: "text-danger"
                  })
                ]),
                _cache[28] || (_cache[28] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary"
                }, "Enregistrer", -1)),
                _cache[29] || (_cache[29] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary ms-2",
                  "data-bs-dismiss": "modal"
                }, "Annuler", -1))
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ])
      ])
    ])
  ]))
}